import { useContext, useEffect, useState } from 'react'
import { defineTipoLink, showNotify } from '../Utils/Utils'
import { iniciarFila, iniciarTimerCamera, pausarTimerCamera, setAtualizarCamera, setCameraPrincipal } from '../Pages/MonitoramentoPage/GridCameras/timer'
import { WebSocketContext } from '../Providers/WebSocket/WebSocketContext'
import { Buffer } from 'buffer'

const useCamera = (camera, cameraPrincipal) => {
    const { addRoute } = useContext(WebSocketContext)

    const [isLoading, setIsLoading] = useState(true)
    const [template, setTemplate] = useState(true)

    const [linkAux, setLinkAux] = useState()

    const { linkInterno, linkExterno, token } = camera

    const link = defineTipoLink(global.tipoLink, linkInterno, linkExterno)

    const setImage = (valor) => {
        setIsLoading(false)
        setLinkAux(valor)
    }

    useEffect(() => {
        if (!link) {
            setTemplate(true)
            return
        }

        if (template) {
            setTemplate(false)
        }

        if (cameraPrincipal) {
            pausarTimerCamera()
            setAtualizarCamera({ setLinkAux: setImage, setCameraTemplate: setTemplate })
            setCameraPrincipal(camera)
            iniciarTimerCamera()
        } else {
            if (token) {
                iniciarFila({ camera, setLinkAux: setImage, setCameraTemplate: setTemplate })
            } else {
                setImage(link)
            }
        }
    }, [link])

    addRoute('getVideo#camera', (msg) => {
        if (isLoading) {
            setIsLoading(false)
        }

        const { status, message } = msg.data

        if (status === 'error' || !status) {
            showNotify('error', message, { autoClose: 3000 })
            return
        }

        const { data } = msg.data.data

        const base64Image = 'data:image/png;base64, ' + Buffer.from(data).toString('base64')

        setLinkAux(base64Image)
    })

    return {
        isLoading,
        template,
        linkAux,
        setTemplate
    }
}

export default useCamera
